import { createContext, useState } from "react";

export const AffiliateProfileContext = createContext();

export function AffiliateProfileProvider({ children }) {
  const [affiliateProfile, setAffiliateProfile] = useState({});

  return (
    <AffiliateProfileContext.Provider
      value={{ affiliateProfile, setAffiliateProfile }}
    >
      {children}
    </AffiliateProfileContext.Provider>
  );
}
